import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["value"]

import { ref } from 'vue';

// Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'TRSelect',
  props: {
    options: {},
    modelValue: {},
    class: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Define emits
const emit = __emit;

// Reactive state
const selectedValue = ref(props.modelValue);

// Emit changes when selection updates
const emitChange = () => {
  emit('update:modelValue', selectedValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      class: _normalizeClass(["w-full", props.class]),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
      onChange: emitChange
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_2))
      }), 128))
    ], 34), [
      [_vModelSelect, selectedValue.value]
    ])
  ]))
}
}

})